import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import styles from "../onboard.module.css";
import { useMyContext } from "../../../myContext";
import CardDetail from "../../../common/CardDetails/CardDetail";
import { statusApi } from "../../../api";
import CommonButton from "../../CommonButton/CommonButton";

function VisitedStudent({
  setSelectedStudentName,
  setModalOpen,
  showStudentDetail,
  setShowStudentDetail,
  studentList,
  shortDetail,
  setShortDetail,
  setStepsToShow,
  setReqDocs,
  studentCardSelection,
  setStudentCardSelection,
}) {
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showNextButton, setShowNextButton] = useState(false);
  const {
    setStudentUserId,
    setCompletedStudent,
    setShowStudentUpload,
    showStudentUpload,
    studentSecondFlow,
    studentUserId,
    remitterUserId,
    // themeColor,
    // setBeneficicaryUserId,
  } = useMyContext();

  useEffect(() => {
    if (selectedStudent) {
      setStudentUserId(selectedStudent.userAccountId);
      checkStudentApproved(selectedStudent.userAccountId);
    }
  }, [selectedStudent]);

  const hanldeNextClick = () => {
    const isThereAnyRelation = shortDetail?.relationships?.find(
      (arr) => arr.remitterUserAccountId === remitterUserId,
    );

    if (!isThereAnyRelation) {
      setModalOpen(true);
      setSelectedStudentName(selectedStudent.fullName);
    } else {
      setShowStudentDetail(true);
      setStudentCardSelection(false);
      // setStudentUserId(selectedStudent.userAccountId);₹
      // sessionStorage.setItem("studentName", selectedStudent.fullName);

      if (showStudentUpload === true) {
        setStepsToShow("StudentStep2");
      } else {
        setCompletedStudent(true);
        setStepsToShow("BeneficiaryStep1");
      }
    }
  };

  const checkStudentApproved = (id) => {
    setShowNextButton(false);
    statusApi(id).then((res) => {
      setReqDocs([]);
      setShortDetail({
        name: res.data.fullName,
        phone: res.data.phone,
        email: res.data.email,
        dob: res.data.dob,
        address: res.data.fullAddress,
        city: res.data.city,
        state: res.data.state,
        postalcode: res.data.postalCode,
        country: "India",
        relationships: res.data?.relationships ?? [],
      });

      var documents = res.data.documents;
      try {
        // Check if document exists and status is verified or pending
        const isDocumentValid = (doc) => {
          const status = doc?.status?.toLowerCase();
          return doc && (status === "verified" || status === "pending");
        };

        const allDocsPresent =
          isDocumentValid(documents.PAN) &&
          isDocumentValid(documents.PASSPORT_FRONT) &&
          isDocumentValid(documents.PASSPORT_BACK);

        if (
          res.status === 200 &&
          Object.keys(documents).length === 3 &&
          allDocsPresent
        ) {
          setShowStudentUpload(false);
        } else {
          if (Object.keys(documents).length !== 0) {
            const reqDocs = [];
            if (!isDocumentValid(documents.PAN)) {
              reqDocs.push("PAN");
            }
            if (!isDocumentValid(documents.PASSPORT_FRONT)) {
              reqDocs.push("Passport");
            }
            if (!isDocumentValid(documents.PASSPORT_BACK)) {
              reqDocs.push("Passport");
            }
            setReqDocs(reqDocs);
            setShowStudentUpload(true);
          } else {
            const reqDocs = ["PAN", "Passport"];
            setReqDocs(reqDocs);
            setShowStudentUpload(true);
          }
        }
        setShowNextButton(true);
      } catch (error) {
        setShowStudentUpload(true);
        setShowNextButton(true);
      }
    });
  };

  return (
    <>
      {showStudentDetail === false && (
        <>
          <CardDetail
            cardlist={studentList}
            setSelectedValue={setSelectedStudent}
            selectedValue={selectedStudent}
            selectedUserid={studentUserId}
          />
          {studentCardSelection === true && studentSecondFlow === true && (
            <Row className="pt-3 mt-3">
              <CommonButton
                title="Next"
                onClick={hanldeNextClick}
                loading={false}
                disabled={selectedStudent === null || !showNextButton}
                width={"150px"}
              />
            </Row>
          )}
        </>
      )}
    </>
  );
}

export default VisitedStudent;
